import { LoadState } from "../../constants/enums";

export interface IEdiXmlTrackingRecord {
  edi_xml_message_tracking_id: number;
  message_guid: string;
  csio_log_code: string;
  policy_number: string;
  customer_policy_id: number;
  message_type: string;
  line_of_business: string | null;
  xml_record: IEdiXmlRecord;
  mapping_status: string | null;
  mapping_error: string | null;
  invoice_status: string | null;
  invoice_error: string | null;
  invoice_id: number | null;
  mapped_ts: string | null;
  invoiced_ts: string | null;
  last_event_ts: string | null;
  status: string;
  create_ts: string;
}

export interface IEdiXmlRecord {
  city: string;
  code: number;
  name: string;
  amount: string;
  source: string;
  status: string;
  address: string;
  policy_id: number;
  amount_due: number;
  invoice_id: number | null;
  amount_paid: number | null;
  branch_code: string;
  broker_code: string;
  expiry_date: string;
  financed_by: string | null;
  invoice_for: string;
  policy_type: string;
  postal_code: string;
  financed_fee: number | null;
  insurer_code: string;
  invoice_date: string;
  message_guid: string;
  invoice_notes: string | null;
  payment_terms: string;
  policy_number: string;
  policy_status: string;
  tax_one_total: number;
  tax_two_total: number;
  effective_date: string;
  invoice_number: string | null;
  invoice_status: string;
  type_of_policy: string;
  broker_sub_code: string;
  invoice_details: IEdiXmlInvoiceDetail[];
  commission_total: number;
  invoice_due_date: string;
  premium_financed: string | null;
  sub_total_dollar: string;
  total_due_dollar: number;
  transaction_date: string;
  province_or_state: string;
  default_tax_region: string;
  is_mannual_invoice: boolean;
  net_payable_insurer: number;
  agency_or_direct_bill: string;
  gl_sales_account_name: string | null;
  policy_comission_code: string;
  policy_transaction_type: string;
  accounting_information_id: number | null;
  invoice_footer_information: string;
  transaction_effective_date: string;
}

export interface IEdiXmlInvoiceDetail {
  key: string;
  type: string | null;
  amount: string;
  detail: string | null;
  status: string;
  broker_code: string;
  description: string | null;
  house_amount: number;
  insurer_code: string;
  total_amount: number;
  branch_amount: number;
  tax_one_amount: number;
  tax_two_amount: number;
  broker_sub_code: string;
  gl_account_code: string;
  house_percentage: number | string;
  transaction_type: string;
  branch_percentage: number | string;
  commission_amount: number;
  tax_one_percentage: number;
  tax_two_percentage: number;
  net_payable_insurer: number;
  producer_one_amount: number;
  producer_two_amount: number;
  commission_percentage: string;
  producer_three_amount: number;
  producer_one_percentage: number | string;
  producer_two_percentage: number | string;
  producer_three_percentage: number | string;
}

export interface IEdiXmlTrackingStats {
  messages: string;
  mappings_total: string;
  mappings_success: string;
  mappings_failed: string;
  invoices_total: string;
  invoices_success: string;
  invoices_failed: string;
  invoices_duplicate: string;
}

export const initialEdiXmlTrackingStats: IEdiXmlTrackingStats = {
  messages: "0",
  mappings_total: "0",
  mappings_success: "0",
  mappings_failed: "0",
  invoices_total: "0",
  invoices_success: "0",
  invoices_failed: "0",
  invoices_duplicate: "0",
};

export interface IEdiXmlTrackingState {
  list: IEdiXmlTrackingRecord[];
  loading: LoadState;
  totalRecords: number;
  stats: IEdiXmlTrackingStats;
  statsLoading: LoadState;
}

export const initialEdiXmlTrackingState: IEdiXmlTrackingState = {
  list: [],
  loading: LoadState.NotLoaded,
  totalRecords: 0,
  stats: initialEdiXmlTrackingStats,
  statsLoading: LoadState.NotLoaded,
};
